// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"aa564c9e","540":"656f7846","895":"b5a8b7d8","901":"dce93830"}[chunkId] + ".chunk.js";
};